import { render, staticRenderFns } from "./characteristics.vue?vue&type=template&id=51f15c07&scoped=true"
import script from "./characteristics.vue?vue&type=script&lang=js"
export * from "./characteristics.vue?vue&type=script&lang=js"
import style0 from "./characteristics.vue?vue&type=style&index=0&id=51f15c07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f15c07",
  null
  
)

export default component.exports